import { defineStore } from 'pinia'
import { ref } from 'vue'

// status of image load
export enum ImageLoadStatus {
  Loading = 'loading',
  Loaded = 'loaded',
  Failed = 'failed',
}

export const useImageLoad = defineStore('loadImage', () => {
  const imageLoadMap = ref<Map<string, ImageLoadStatus>>(new Map())
  function setImageLoadStatus(url: string, status: ImageLoadStatus) {
    imageLoadMap.value.set(url, status)
  }

  function getImageLoadStatus(url: string) {
    return imageLoadMap.value.get(url)
  }

  function loadImage(url: string) {
    const img = new Image()

    img.onload = () => {
      // Update the status in the store to 'Loaded'
      setImageLoadStatus(url, ImageLoadStatus.Loaded)
      console.debug(`[ImageLoad] Loaded ${url}`)
    }

    img.onerror = () => {
      // Update the status in the store to 'Failed'
      setImageLoadStatus(url, ImageLoadStatus.Failed)
    }

    // Update the status in the store to 'Loading'
    setImageLoadStatus(url, ImageLoadStatus.Loading)
    img.src = url
  }
  return {
    imageLoadMap,
    setImageLoadStatus,
    getImageLoadStatus,
    loadImage,
  }
})
